// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__9xgMk","textContainer":"style_textContainer__+jNf1","map":"style_map__sAcZy"};